import { initTeamMembersCarousel } from '@components/sliders/sliders'

document.addEventListener('DOMContentLoaded', () => {
  initTeamMembersCarousel()
}, { once: true })
